import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import ImageDetail from '@/views/ImageDetail.vue'
import WhisperTest from '@/views/WhisperTest.vue'
import VlmTest from '@/views/VlmTest.vue'
import WebcamTest from '@/views/webcamTest.vue'
import ArucoMarker from '@/views/ArucoMarker.vue'
import TextDetail from '@/views/TextDetail.vue'
import QADetail from '@/views/QADetail.vue'
import ExcelTest from '@/views/ExcelTest.vue'
import dotCanvas from '@/views/dotCanvas.vue'
import store from "@/store";
import { checkLogin } from "@/utils/auth";

let isCheckingAuth = false;



const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage
  },
  {
    path: '/image/:id',
    name: 'ImageDetail',
    component: ImageDetail,
    props: true
  },
  {
    path: '/whisper-test',
    name: 'WhisperTest',
    component: WhisperTest
  },
  {
    path: '/vlm-test',
    name: 'VlmTest',
    component: VlmTest
  },
  {
    path: '/webcam-test',
    name: 'WebcamTest',
    component: WebcamTest
  },
  {
    path: '/Aruco',
    name: 'ArucoMarker',
    component: ArucoMarker
  },
  {
    path: '/',
    name: 'TextDetail',
    component: TextDetail
  },
  {

    path: '/',
    name: 'QADetail',
    component: QADetail
  },
  {
    path: '/excel-test',
    name: 'ExcelTest',
    component: ExcelTest

  },
  {
    path: '/QA-test',
    name: 'QATest',
    component: QADetail

  },
  {
    path: "/dotCanvas",
    name: "dotCanvas",
    component: dotCanvas,
  },
  {
    path: '/login-callback',
    name: 'LoginCallback',
    component: () => import('@/views/LoginCallback.vue')
  }


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

let hasCheckedAuth = false;

router.beforeEach(async (to, from, next) => {
  if (to.name === "LoginCallback") {
    return next();
  }

  if (!hasCheckedAuth) {
    await checkLogin(store);
    hasCheckedAuth = true;
  }

  next();
});


export default router
